import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("velvet_cart")) || [];
    } catch {
      return [];
    }
  });
  const [isOpen, setIsOpen] = useState(false);
  const [couponCode, setCouponCode] = useState(() => {
    try {
      return localStorage.getItem("velvet_coupon") || "";
    } catch {
      return "";
    }
  });

  useEffect(() => {
    localStorage.setItem("velvet_coupon", couponCode);
  }, [couponCode]);

  useEffect(() => {
    localStorage.setItem("velvet_cart", JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1, variant = "") =>
    setItems((prev) => {
      const existing = prev.find((i) => i.id === product.id && (i.variant || "") === variant);
      if (existing) return prev.map((i) => (i.id === product.id && (i.variant || "") === variant ? { ...i, qty: i.qty + qty } : i));
      const price = variant ? (product.variants?.find((v) => v.title === variant)?.price ?? product.price) : product.price;
      return [
        ...prev,
        { id: product.id, name: product.name, price, image: product.image, brand_slug: product.brand_slug, variant, qty },
      ];
    });

  const remove = (id, variant = "") => setItems((prev) => prev.filter((i) => !(i.id === id && (i.variant || "") === variant)));
  const setQty = (id, qty, variant = "") =>
    setItems((prev) =>
      qty <= 0
        ? prev.filter((i) => !(i.id === id && (i.variant || "") === variant))
        : prev.map((i) => (i.id === id && (i.variant || "") === variant ? { ...i, qty } : i))
    );
  const clear = () => { setItems([]); setCouponCode(""); };

  const count = items.reduce((s, i) => s + i.qty, 0);
  const total = items.reduce((s, i) => s + i.qty * i.price, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, count, total, isOpen, setIsOpen, couponCode, setCouponCode }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
